import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import ReactGA from 'react-ga4';
import useAuth from './Auth';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import KeyIcon from '@mui/icons-material/Key';
import { useThemeContext } from '../ThemeProvider';

type WelcomeBackDialogProps = {
	open: boolean;
	onClose: () => void;
};

const WelcomeBackDialog = ({ open, onClose }: WelcomeBackDialogProps) => {
	const { loginWithRedirect } = useAuth();
	const { analyticsConsent } = useCookieConsent();

	const handleLoginClick = () => {
		loginWithRedirect();
		if (analyticsConsent) {
			ReactGA.event({
				category: 'Authentication',
				action: 'Login',
			});
		}
	};

	const handleContinueOfflineClick = () => {
		onClose();
		if (analyticsConsent) {
			ReactGA.event({
				category: 'UI',
				action: 'WelcomeBackContinueOfflineClicked',
			});
		}
	};

	const { isDarkModeOn } = useThemeContext();

	return (
		<Dialog
			open={open}
			fullWidth
			maxWidth='xs'
			scroll='body'
			slotProps={{
				paper: {
					elevation: 0,
				},
			}}
		>
			<Box display='flex' flexDirection='column' alignItems='center' gap={1} mt={4}>
				{isDarkModeOn ? <img src='/logo-feather-dark.svg' height='64' alt='Untwyn logo' /> : <img src='/logo-feather.svg' height='64' alt='Untwyn logo' />}
			</Box>
			<DialogTitle sx={{textAlign: 'center'}}>You&apos;re offline</DialogTitle>
			<DialogContent>
				<Typography variant='body2' color='text.secondary'>
					You are currently not signed in. How would you like to continue?
				</Typography>
			</DialogContent>
			<DialogActions sx={{px: 3, pb: 4, display: 'flex', flexDirection: 'column', gap: 1}}>
				<Button variant='contained' onClick={handleLoginClick} startIcon={<KeyIcon />} sx={{px: 2.5}}>
					Sign in to my cloud workspace
				</Button>
				<Typography variant='body2' color='text.secondary'>
					or
				</Typography>
				<Button variant='outlined' onClick={handleContinueOfflineClick}>
					Continue offline
				</Button>
			</DialogActions>
			<Box display='flex' justifyContent='center' pb={2}>
				<Typography variant='caption' color='text.secondary' textAlign='center' mt={2}>
					Untwyn &middot; 2026
				</Typography>
			</Box>
		</Dialog>
	);
};

export default WelcomeBackDialog;
